import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Loading, EmptyState, StatusBadge } from "@/components/common";
import { numberID, formatDateTime } from "@/lib/format";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Lock } from "lucide-react";

export default function Reservasi() {
  const [rows, setRows] = useState(null);
  const [tab, setTab] = useState("active");
  useEffect(() => { setRows(null); api.get("/inventory/reservations", { params: tab === "all" ? {} : { status: tab } }).then((r) => setRows(r.data)); }, [tab]);
  return (
    <div>
      <PageHeader title="Reservasi Stok" subtitle="Reservasi mencegah overselling lintas 10 toko pada stok pusat bersama." testId="reservasi-header" />
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger value="active" data-testid="tab-active">Aktif</TabsTrigger>
          <TabsTrigger value="fulfilled" data-testid="tab-fulfilled">Terpenuhi</TabsTrigger>
          <TabsTrigger value="released" data-testid="tab-released">Dilepas</TabsTrigger>
          <TabsTrigger value="all" data-testid="tab-all">Semua</TabsTrigger>
        </TabsList>
        <TabsContent value={tab} className="mt-4">
          <div className="rounded-xl border border-slate-200 bg-white shadow-sm">
            {!rows ? <Loading /> : rows.length === 0 ? <EmptyState title="Tidak ada reservasi" icon={Lock} /> : (
              <div className="overflow-x-auto">
                <Table>
                  <TableHeader><TableRow><TableHead>No. Pesanan</TableHead><TableHead>SKU</TableHead><TableHead className="text-right">Qty</TableHead><TableHead>Status</TableHead><TableHead>Waktu</TableHead></TableRow></TableHeader>
                  <TableBody>
                    {rows.map((r) => (
                      <TableRow key={r.id} data-testid={`res-row-${r.id}`}>
                        <TableCell className="font-mono text-xs">{r.order_no}</TableCell>
                        <TableCell className="font-mono text-xs text-indigo-700">{r.sku}</TableCell>
                        <TableCell className="text-right font-semibold">{numberID(r.qty)}</TableCell>
                        <TableCell><StatusBadge status={r.status === "active" ? "Diproses" : r.status === "fulfilled" ? "Selesai" : "Dibatalkan"} label={r.status} /></TableCell>
                        <TableCell className="text-xs text-slate-500">{formatDateTime(r.created_at)}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            )}
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
}
